/* eslint-disable no-param-reassign */
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['label', 'content'];

  toggleIndex(i) {
    this.contentTargets.forEach((content, x) => {
      if (i === x) {
        content.style.display = 'block';
      } else {
        content.style.display = 'none';
      }
    });

    this.labelTargets.forEach((label, x) => {
      if (i === x) {
        label.parentElement.classList.add('active');
      } else {
        label.parentElement.classList.remove('active');
      }
    });
  }

  toggle(e) {
    const i = this.labelTargets.indexOf(e.target);
    this.toggleIndex(i);
  }

  beforeCache() {
    this.toggleIndex(0);
  }
}
